'use client';
import type { Assign } from '@ark-ui/react';
import { Clipboard } from '@ark-ui/react';
import { type ClipboardVariantProps, clipboard } from '@terra/ui-styled-system';
import type { ComponentProps, HTMLStyledProps } from '@terra/ui-styled-system';
import { createStyleContext } from './utils/create-style-context';

const { withProvider, withContext } = createStyleContext(clipboard);

export type RootProviderProps = ComponentProps<typeof RootProvider>;
export const RootProvider = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, Clipboard.RootProviderProps>,
    ClipboardVariantProps
  >
>(Clipboard.RootProvider, 'root');

export type RootProps = ComponentProps<typeof Root>;
export const Root = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, Clipboard.RootProps>,
    ClipboardVariantProps
  >
>(Clipboard.Root, 'root');

export const Control = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Clipboard.ControlProps>
>(Clipboard.Control, 'control');

export const Indicator = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Clipboard.IndicatorProps>
>(Clipboard.Indicator, 'indicator');

export const Input = withContext<
  HTMLInputElement,
  Assign<HTMLStyledProps<'input'>, Clipboard.InputProps>
>(Clipboard.Input, 'input');

export const Label = withContext<
  HTMLLabelElement,
  Assign<HTMLStyledProps<'label'>, Clipboard.LabelProps>
>(Clipboard.Label, 'label');

export const Trigger = withContext<
  HTMLButtonElement,
  Assign<HTMLStyledProps<'button'>, Clipboard.TriggerProps>
>(Clipboard.Trigger, 'trigger');

export { ClipboardContext as Context } from '@ark-ui/react';
